import {jsonp} from 'rlink-utils/xhr';

export class TwitchService {
  constructor (clientId) {
    this.apiEndPoint = 'https://api.twitch.tv/kraken';
    this.apiVersion = 3;
    this.clientId = clientId;
  }

  apiRequest (options) {
    options = options || {};
    options.url = (options.url) ? options.url : this.apiEndPoint + options.path;
    options.data = options.data || {};
    options.data.client_id = this.clientId;
    options.data.api_version = this.apiVersion;

    return jsonp('callback', options.url, options.data).then(responseRaw => this.parseResponse(responseRaw)).catch(error => {
      if (error === undefined) error = {};
      if (error.error === undefined) {
        error.error = "SERVER_ERROR";
      }
      throw error;
    });
  }

  parseResponse (responseRaw) {
    let response = responseRaw.text;
    if (response.error !== undefined) {
      throw {
        error: response.error,
        message: response.message
      };
    } else {
      let parsedMediaData = {};
      if ('stream' in response && response.stream !== null) {
        parsedMediaData = this.formatStreams([response.stream]);
      } else if ('streams' in response && response.streams.length > 0) {
        parsedMediaData = this.formatStreams(response.streams);
      } else if ('videos' in response) {
        parsedMediaData = this.formatVideos(response.videos);
      }

      let responseData = { nextPage: response['_links'].next, streams:[], broadcasts:[] };
      return Object.assign(responseData, parsedMediaData);
    }
  }

  formatStreams (streams) {
    return { streams: streams.map(stream => {
      let channelName = stream.channel['display_name'];
      return {
        id: stream._id,
        channel: channelName,
        url: 'http://www.twitch.tv/' + channelName,
        views: stream.viewers,
        previewUrl: stream.preview.large,
        live: true,
        age: 0,
        game: stream.game
      };
    })};
  }

  formatVideos (videos) {
    return { broadcasts: videos.map(video => {
      return {
        id: video._id,
        channel: video.channel['display_name'],
        url:video.url,
        views: video.views,
        previewUrl: video.preview,
        live: false,
        age: Math.floor((Date.now() - Date.parse(video.recorded_at)) / (1000*60*60*24)),
        game: video.game,
        title: video.title,
      }
    })};
  }

  getChannelVideos (channelName, apiLimit) {
    let options = {
      path: '/channels/' + channelName + '/videos',
      data: {
        limit: apiLimit,
        broadcasts: true,
      }
    };

    return this.apiRequest(options);
  }

  getNextPage (url) {
    return this.apiRequest({url: url});
  }

  getChannelStream (channelName) {
    let options = {
      path: '/streams/' + channelName
    };

    return this.apiRequest(options);
  }

  getStreams (criteria) {
    let options = {
      path: '/streams',
      data: criteria
    };

    return this.apiRequest(options);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-twitch/service.js